module.exports = __webpack_public_path__ + "b89814960d289ff4ba86d313fe4b03bb.mp4";